import { flatten, sortBy, uniq } from 'lodash-es';
import { DEFAULT_CATEGORY, certifiedPreOwnedText } from 'client/site-modules/dealerships/constants/dealerships-landing';

/**
 * Get array of unique photo tags
 * @returns {Array.<T>}
 */
export function getTagsFromPhotosArray(showroomPhotos) {
  const tagsArray = uniq(flatten(showroomPhotos && showroomPhotos.map(photo => photo.tags || []))).sort();
  const cpoTagIndex = tagsArray.indexOf('CPO');
  // replace 'CPO' tag with 'CERTIFIED PRE-OWNED'
  if (cpoTagIndex > -1) {
    tagsArray[cpoTagIndex] = certifiedPreOwnedText;
  }
  return tagsArray;
}

export function groupPhotosByTag({ showroomPhotos, logoUrl, tagList }) {
  if (!(showroomPhotos && showroomPhotos.length)) return DEFAULT_CATEGORY;
  const sortedPhotos = sortBy(showroomPhotos, ['order']);
  // check if logo duplicates in photos array
  const logoIndex = sortedPhotos.map(photo => photo.photoUrl).indexOf(logoUrl);
  if (logoIndex > -1) {
    sortedPhotos.splice(logoIndex, 1);
  }
  const categories = {};
  categories.DEFAULT = sortedPhotos;
  tagList.forEach(tag => {
    categories[tag] = sortedPhotos.filter(
      photo => photo.tags && photo.tags.indexOf(tag === certifiedPreOwnedText ? 'CPO' : tag) > -1
    );
  });
  return categories;
}
